/**
 * External destinations surfaced inside the app.
 * Community hub (knowledge base / forum / billing) and the referral form.
 * Added 2026-05-29 per Alex's request — see PR for placements.
 */
export const COMMUNITY_HUB_URL = 'https://chorosapp.com/community-hub'
export const REFERRAL_URL = 'https://chorosreferral.carrd.co/'

/**
 * Returns true when running inside the Capacitor native shell.
 * Safe to call synchronously — reads the global Capacitor bridge that the
 * native runtime injects before any JS executes.
 */
export function isNativePlatform(): boolean {
	return (
		typeof window !== 'undefined' &&
		(window as any).Capacitor?.isNativePlatform?.() === true
	)
}

/**
 * Open an external URL in the device's system browser when running inside the
 * native (Capacitor) app, and in a new tab on the web.
 *
 * Using the Capacitor Browser plugin on native opens Safari/Chrome rather than
 * the in-app webview, so users aren't trapped without a way back. Imports are
 * lazy + window-guarded so this stays safe to call from code shared with the
 * server-rendered web build.
 */
export async function openExternalUrl(url: string): Promise<void> {
	if (typeof window === 'undefined') return
	try {
		const { Capacitor } = await import('@capacitor/core')
		if (Capacitor.isNativePlatform()) {
			const { Browser } = await import('@capacitor/browser')
			await Browser.open({ url })
			return
		}
	} catch {
		// fall through to web behavior
	}
	window.open(url, '_blank', 'noopener,noreferrer')
}
